import { useEffect } from 'react';

import { useLEAccordionItemContext } from '../../../../../components/LEAccordion/LEAccordionItem/useLEAccordionItem';
import { useOnceWhen } from '../../../../../hooks';
import { trackPhotosCompleted } from '../../../../../services/analytics/marketplaceEvents';

const usePrelistStepStatus = (dealId: string, isComplete: boolean) => {
  const { updateState } = useLEAccordionItemContext();

  useEffect(() => {
    updateState({ status: isComplete ? 'complete' : 'none' });
  }, [isComplete]);

  useOnceWhen(isComplete, () => trackPhotosCompleted(dealId));
};

export default usePrelistStepStatus;
